import BaseService from './baseService';
import cloneDeep from 'lodash/cloneDeep'

class ProductCategories extends BaseService {
	async getProductCategories(opts = {}) {
    this.endPoint = '/product-category';
		return this.get(opts);
  }
  async createProductCategories(payload){
    this.endPoint = '/product-category';
    return await this.post(payload); 
  }
  async updateProductCategories(id,payload,opts={}){
    this.endPoint = '/product-category';
    return await this.putOne(id,payload,opts);
  }
  async deleteProductCategories(id,opts={}){
    this.endPoint = '/product-category';
    return await this.delete(id,opts);
  }

  async getCategoryProductById(id,opts = {}) {
    this.endPoint = '/product-category/'+id;
		return this.get(opts);
  }

  async uploadImage(data,opts={}) {
    this.endPoint = 'uploadAttachmentProductCategory';
    const newOpts = cloneDeep(opts, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })

    return this.post(data, newOpts)
    // return await this.post(payload);
  }
  async removeImage(id,opts={}) {
    this.endPoint = 'deleteAttachmentProductCategory';
    return await this.delete(id,opts={});
  }
}

export default new ProductCategories();